// TODO: (Kevin, 2017-09-11) Just a sample!
export const CategoryDefaultForm = {
    groups: [{
        sections: [{
            rows: [{
                elements: [{
                    id: 'name',
                    type: 'text',
                    name: 'name',
                    label: 'Title',
                    validation: {
                        required: true,
                    },
                    options: {},
                    attributes: {
                        placeholder: '',
                        title: 'Title'
                    },
                }, {
                    id: 'description',
                    type: 'text',
                    name: 'description',
                    label: 'Description',
                    validation: {},
                    options: {},
                    attributes: {
                        placeholder: '',
                        title: 'Description'
                    },
                }]
            }]
        }]
    }]
};



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/categories/forms/category/default.form.ts